import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import MyBatchesHeaderAntd, {
  setChapterHandler,
} from "Pages/MyBatchesAntd/MyBatchesHeaderAntd";
import MyBatchesTableAntd from "Pages/MyBatchesAntd/MyBatchesTableAntd";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  BASE_URL,
  MY_BATCHES_LIST,
} from "utilFunctions/Constants/urlConstants";
import dayjs from "dayjs";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Tabs } from "antd";
export const StyledTabs = styled<any>(Tabs)`
  padding-left: ${(props: any) =>
    !["xs", "sm", "md"].includes(props.screen) ? "0px" : "0px"};
  .ant-tabs-nav {
    margin-bottom: 0;
    padding-right: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "12px" : "0px"};
    background: #fff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .ant-tabs-nav::before {
    border: 0px !important;
  }
  .ant-tabs-tab {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .ant-tabs-content-holder {
    height: calc(100vh - 180px);
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 12px;
  }
  .ant-tabs-nav-wrap {
    padding-left: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "12px" : "40px"};
    background: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;
export const StyledMainDiv = styled<any>("div")`
  margin-top: 16px;
  margin-right: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
  margin-left: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen)
      ? "xxl" === screen
        ? "44px"
        : "16px"
      : "0px"};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const date = new Date();
const month = String(date.getMonth() + 1); // Months are 0-based, so we add 1
const year = String(date.getFullYear()).slice(-2); // Get the last two digits of the year

const MyBatchesAntd = () => {
  const { screen }: any = useWindowSize();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const ToastDispatch = useContext(ToastContextDispatch);
  const [BatchesData, setBatchesData] = useState<any>([]);
  const [chapterData, setChapterData] = useState<any>([]);
  const [refresh, setRefresh] = useState<any>(false);
  const currentDate = dayjs().format("MMM-YYYY");
  const [activeTab, setactiveTab] = useState("1");
  const [filterState, setfilterState] = useState<any>({
    email: null,
    plannedLecture: "plannedLectures",
    month: currentDate,
    chipFieldName: {
      month: currentDate,
      plannedLecture: "plannedLectures",
    },
  });
  const { makeRequest: GetBATCHDATA, loading } = useGetApi(
    (data) => {
      console.log("isBatchesData", data, data["data"]);
      if (data && data["data"] && data["data"].length) {
        if (chapterData.length && filterState?.plannedLecture == "chapter") {
          setBatchesData(setChapterHandler(data["data"], chapterData));
        } else {
          setBatchesData(data["data"]);
        }
      } else {
        setBatchesData([]);
      }
    },
    (error) => {
      setBatchesData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    let url = BASE_URL + MY_BATCHES_LIST + "?month=" + month + "&year=" + year;
    if (
      localStorage.getItem("myBatchsFilter") &&
      JSON.parse(localStorage.getItem("myBatchsFilter") as any)
    ) {
      const parsedFilter: any = JSON.parse(
        localStorage.getItem("myBatchsFilter") as any
      );
      url = url + "&facultyId=" + parsedFilter?.employeeId;
      GetBATCHDATA(url);
    } else {
      url = url + "&facultyId=" + userInfo?.employeeId;
      GetBATCHDATA(url);
    }
  }, [userInfo, location, refresh]);
  const handleSearchFaculty = (selectedFaculty: any) => {
    localStorage.setItem("myBatchsFilter", JSON.stringify(selectedFaculty));
    if (selectedFaculty != null) {
      const url =
        BASE_URL +
        MY_BATCHES_LIST +
        "?facultyId=" +
        selectedFaculty.employeeId +
        "&month=" +
        month +
        "&year=" +
        year;
      GetBATCHDATA(url);
    } else {
      setRefresh(new Date().getMilliseconds());
    }
  };
  const handleMonthYearFilter = (mnth: string, yr: string) => {
    let url = BASE_URL + MY_BATCHES_LIST + "?month=" + mnth + "&year=" + yr;
    if (
      localStorage.getItem("myBatchsFilter") &&
      JSON.parse(localStorage.getItem("myBatchsFilter") as any)
    ) {
      const parsedFilter: any = JSON.parse(
        localStorage.getItem("myBatchsFilter") as any
      );
      url = url + "&facultyId=" + parsedFilter?.employeeId;
      GetBATCHDATA(url);
    } else {
      url = url + "&facultyId=" + userInfo?.employeeId;
      GetBATCHDATA(url);
    }
  };
  console.log("activeTabactiveTab", activeTab, BatchesData);
  return (
    <StyledMainDiv screen={screen} style={{ gap: "0px" }}>
      <MyBatchesHeaderAntd
        cardTitle={"My Batches"}
        chapterData={chapterData}
        setChapterData={setChapterData}
        BatchesData={BatchesData}
        setBatchesData={setBatchesData}
        handleSearchFaculty={handleSearchFaculty}
        handleMonthYearFilter={handleMonthYearFilter}
        filterState={filterState}
        setfilterState={setfilterState}
        currentDate={currentDate}
      ></MyBatchesHeaderAntd>
      <StyledTabs
        screen={screen}
        activeKey={activeTab}
        onChange={(key: any) => setactiveTab(key)}
        items={[
          {
            key: "1",
            label: "Overview",
            children: (
              <TableLayoutAntd isLoader={loading}>
                <MyBatchesTableAntd
                  data={BatchesData}
                  access={[
                    "batchName",
                    "class",
                    "subject",
                    "totalNumberOfStudents",
                    "markedAttdCount",
                    "action",
                  ]}
                  setData={setBatchesData}
                  activeTab={activeTab}
                ></MyBatchesTableAntd>
              </TableLayoutAntd>
            ),
          },
          {
            key: "2",
            label: "Syllabus Compliance",
            children: (
              <TableLayoutAntd isLoader={loading}>
                <MyBatchesTableAntd
                  data={BatchesData}
                  access={[
                    "batchName",
                    "class",
                    "subject",
                    "plLecStatus",
                    "plLecStatusSyllabus",
                    "unMarkedLectureCount",
                    "action",
                  ]}
                  setData={setBatchesData}
                  activeTab={activeTab}
                ></MyBatchesTableAntd>
              </TableLayoutAntd>
            ),
          },
          {
            key: "3",
            label: "Test Compliance",
            children: (
              <TableLayoutAntd isLoader={loading}>
                <MyBatchesTableAntd
                  data={BatchesData}
                  access={[
                    "batchName",
                    "class",
                    "subject",
                    "testType",
                    "testSyllbStatus",
                    "pendingEvaluations",
                    "action",
                  ]}
                  setData={setBatchesData}
                  activeTab={activeTab}
                ></MyBatchesTableAntd>
              </TableLayoutAntd>
            ),
          },
        ]}
      ></StyledTabs>
    </StyledMainDiv>
  );
};

export default MyBatchesAntd;
